import { Dealer } from 'entities/dealer';
import { OutsideDealer } from 'entities/outside_dealer';

/**
 * 業者
 */
export type Supplier = Dealer | OutsideDealer;

export const partnerLabels = [
  { value: 'Dealer', label: 'パートナー' },
  { value: 'OutsideDealer', label: '外部業者' },
];

// TODO: 編集フォームを実装する際は entities/instrument.ts のコメントと実装を参考に、同様の構造で実装する
